module.exports = __webpack_public_path__ + "img/lubnan.db1d8d65.svg";